import React, { useState } from 'react';
import { Form, Modal, Select, Button, Input } from 'antd';
import { STATES, DENIAL_REASONS } from "../../../helpers/constants";

const ApplicationDenialModal = ({ onFinish, onCancel }) => {

  const denialReasons = {
    [STATES.denialByShop]: {
      [DENIAL_REASONS.SUSPICIOUS_CUSTOMER]: { text: 'Կասկածելի հաճախորդ', comment: false },
      [DENIAL_REASONS.NON_COMPETITIVE_OFFER]: { text: 'Ոչ մրցունակ առաջարկ', comment: false },
      [DENIAL_REASONS.OTHER]: { text: 'Այլ', comment: true }
    },
    [STATES.denialByCustomer]: {
      [DENIAL_REASONS.INSUFFICIENT_CONDITIONS]: { text: 'Ոչ բավարար պայմաններ', comment: false },
      [DENIAL_REASONS.CHANGE_INTENTION]: { text: 'Մտադրության փոփոխություն', comment: false },
      [DENIAL_REASONS.UNFAVORABLE_CREDIT_CONDITIONS]: { text: 'Ոչ բարենպաստ վարկային պայմաններ', comment: false }
    }
  }

  const [denialState, setDenialState] = useState(null)
  const [denialReason, setDenialReason] = useState(null)

  const CloseSvg = () => (
    <svg width="24" height="24" viewBox="0 0 24 24">
      <path id="prefix__a" d="M20.993 5.02L14.013 12l6.98 6.98c.556.556.556 1.457 0 2.013-.556.556-1.457.556-2.013 0L12 14.013l-6.98 6.98c-.556.556-1.457.556-2.013 0-.556-.556-.556-1.457 0-2.013L9.987 12l-6.98-6.98c-.556-.556-.556-1.457 0-2.013.556-.556 1.457-.556 2.013 0L12 9.987l6.98-6.98c.556-.556 1.457-.556 2.013 0 .556.556.556 1.457 0 2.013z" />
    </svg>
  );

  const denialStateChange = (val) => {
    setDenialState(val)
    setDenialReason(null)
  }

  return (
    <Modal
      title="Հայտի չեղարկում"
      closeIcon={<CloseSvg />}
      onCancel={onCancel}
      visible
      wrapClassName='action-dialog'
      footer={null}
      width={720}
      centered
    >
      <div style={{ padding: "12", margin: "12px auto", width: 280 }}>
        <Form
          layout='vertical'
          onFinish={onFinish}
        >
          <Form.Item
            label="Չեղարկող"
            name="state"
            rules={[{ required: true, message: 'Դաշտը պարտադիր է' }]}
          >
            <Select value={denialState} onChange={denialStateChange}>
              <Select.Option value={STATES.denialByCustomer} key={STATES.denialByCustomer}>Հաճախորդ</Select.Option>
              <Select.Option value={STATES.denialByShop} key={STATES.denialByShop}>Խանութ</Select.Option>
            </Select>
          </Form.Item>

          <Form.Item
            label="Պատճառ"
            name="reason"
            rules={[{ required: true, message: 'Դաշտը պարտադիր է' }]}
          >
            <Select value={denialReason || undefined} onChange={setDenialReason}>
              {denialState && denialReasons[denialState] && Object.keys(denialReasons[denialState]).map(reason => (
                <Select.Option key={reason} value={reason}>{denialReasons[denialState][reason].text}</Select.Option>
              ))}
            </Select>
          </Form.Item>

          {denialState && denialReasons[denialState] && denialReasons[denialState][denialReason] && denialReasons[denialState][denialReason].comment && (
            <Form.Item
              name="otherReasonMessage"
              rules={[{ required: true, message: 'Դաշտը պարտադիր է' }]}
            >
              <Input placeholder='Նշել պատճառը'/>
            </Form.Item>
          )}

          <Form.Item>
            <Button
              style={{ margin: '0 auto 8px', width: '280px', height: '48px' }}
              className='btn-yellow'
              size={"large"}
              type="primary"
              htmlType="submit"
            >
              Չեղարկել
            </Button>
          </Form.Item>
        </Form>
      </div>
    </Modal>
  )

}

export default ApplicationDenialModal